export enum FilterType {
  SINGLE_SELECT,
  MULTI_SELECT,
}
